import axios from 'axios';
import { makeAutoObservable } from 'mobx';
import Staff from './models/Staff';
import { requestGet } from '../../services/real.backend';

class PerfectumStorage {
  apiUrl = null;

  loadingStatuses = {
    staff: false,
  }

  cache = {
    staff: null,
  }

  constructor() {
    makeAutoObservable(this);
  }

  config = (params) => {
    this.apiUrl = params.apiUrl;
  }

  get staff() {
    if (!this.cache.staff && !this.loadingStatuses.staff) {
      this.loadingStatuses.staff = true;
      requestGet(`${this.apiUrl}/staff`).then((response) => {
        console.log(response);
        this.setStaff(response);
        this.loadingStatuses.staff = false;
        console.log('Staff loaded', this.cache.staff);
      });
    }
    return this.cache.staff;
  }

  setStaff(staff) {
    this.cache.staff = staff
      .sort((a, b) => a.lastname.localeCompare(b.lastname))
      .map((person) => new Staff(person));
  }

  set(key, value) {
    this.storage.set(key, value);
  }

  remove(key) {
    this.storage.remove(key);
  }

  clear() {
    this.storage.clear();
  }
}

const perfectumStorage = new PerfectumStorage();

export default perfectumStorage;
